import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useSetEntityData = () => {
  const setEntityData = useEntityDetailsDataStore(
    (state) => state.setEntityData,
  );
  return setEntityData;
};
